import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
let LandingPageService = class LandingPageService {
    loginButtonClicked = new BehaviorSubject(null);
    constructor() {
    }
    static ctorParameters = () => [];
};
LandingPageService = __decorate([
    Injectable({
        providedIn: "root"
    })
], LandingPageService);
export { LandingPageService };
